export default __webpack_public_path__ + "static/media/38_desktop.addfcf7c.jpeg";